<template>
  <div @click="hideModals">
    <div class="col-12 parent-desc d-flex justify-content-between first">
      <!-- <div>Edit Transaction Details</div> -->
      <div>
        {{
          transactionDetails.id &&
          transactionDetails.debitSplitAccounts &&
          transactionDetails.debitSplitAccounts.length > 0
            ? "Edit Expense"
            : transactionDetails.id
            ? "Edit Income"
            : transactionDetails.account === "Expense Account"
            ? "Add Expense"
            : "Add Income"
        }}
      </div>
      <el-icon @click="closeTransac" class="mt-0">
        <Close />
      </el-icon>
    </div>
    <div class="container">
      <div
        class="row mt-3"
        v-if="gettingExpenseAccounts || gettingSelectedTrsn"
      >
        <div class="col-md-12 text-center">
          <el-icon class="is-loading">
            <Loading />
          </el-icon>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <!-- <div class="container"> -->
          <div class="row">
            <div class="col-md-6">
              <label class="label-text" for=""
                >Date <span class="text-danger">*</span></label
              >
              <el-date-picker
                v-model="transacObj.date"
                type="date"
                class="w-100 date-picker-size"
                size="large"
                format="MM/DD/YYYY"
              />
            </div>
            <div class="col-md-6">
              <label
                for=""
                class="form-label label-text"
                style="font-size: 14px"
                >Add Description<span class="text-danger">*</span></label
              >
              <el-input
                v-model="transacObj.memo"
                type="text"
                placeholder="Description"
                class="w-100"
              />
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row h-100">
              <div class="col-md-6 mt-2">
                <div class="label-text">Cash Account</div>
                <div
                  class="select-elem-con pointer form- d-flex justify-content-space-between align-items-center close-modal c-pointer"
                  @click="showAccount = !showAccount"
                >
                  <span class="ofering close-modal">{{
                    selectedCashAccount && selectedCashAccount.name
                      ? selectedCashAccount.name
                      : selectedCashAccount && selectedCashAccount.text
                      ? selectedCashAccount.text
                      : "Select"
                  }}</span
                  ><span>
                    <i
                      class="pi pi-angle-down close-modal"
                      aria-hidden="true"
                    ></i
                  ></span>
                </div>
                <div
                  class="ofering close-modal"
                  :class="{ 'style-account': showAccount }"
                  v-if="showAccount"
                  ref="selectAccount"
                >
                  <div class="px-3 pt-3 close-modal">
                    <input
                      type="text"
                      placeholder="Search"
                      class="form-control ofering mb-1 close-modal"
                      v-model="accountText"
                    />
                  </div>

                  <div class="container-fluid">
                    <!-- {{ filteredCashandBank }} -->
                    <div class="row">
                      <div
                        class="col-md-12 px-0"
                        v-for="(account, index) in filteredCashandBank"
                        :key="index"
                        @click="accountFlow($event, account)"
                      >
                        <div class="header-border hover-text close-modal">
                          <div v-if="account">
                            <div
                              class="close-modal offset-sm-1 py-2 small-text"
                            >
                              {{ account.text }}
                            </div>
                          </div>
                          <div v-else>
                            <div class="text-center px-3 py-2 text-danger">
                              No Match Found
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-md-12"
                        v-if="filteredCashandBank.length === 0"
                      >
                        <div class="text-center px-3 py-2 text-danger">
                          No Match Found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-12 px-0 mt-2">
                  <div class="label-text">Amount</div>
                  <el-input
                    type="number"
                    v-model="transacObj.amount"
                    placeholder="0.00"
                    class="w-100"
                  >
                    <template #prefix>
                      <span
                        class="w-100"
                        style="margin-right: 1rem; color: #606266"
                        >{{
                          selectedCashAccount && selectedCashAccount.currency
                            ? selectedCashAccount.currency.shortCode
                            : ""
                        }}</span
                      >
                    </template>
                  </el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 font-weight-bold s-16 text-right text-dak">
            {{
              isNaN(transacObj.amount) || !transacObj.amount
                ? ""
                : Math.round(transacObj.amount).toLocaleString()
            }}
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="col-md-12 h-100 border-radius-8 border-gray-400 py-3">
            <div class="row h-100">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div v-if="true">
                      <div class="row mt-2">
                        <div
                          class="col-md-12 px-0"
                          v-for="(i, index) in splittedTransactions"
                          :key="index"
                        >
                          <div
                            class="dropdown cursor-pointer d-flex align-items-center"
                          >
                            <div
                              :class="{
                                'col-12': splittedTransactions.length === 1,
                                'col-md-6 mt-3':
                                  splittedTransactions.length > 1,
                              }"
                            >
                              <div class="label-text">
                                {{
                                  transactionDetails.id &&
                                  transactionDetails.debitSplitAccounts &&
                                  transactionDetails.debitSplitAccounts.length >
                                    0
                                    ? "Expense Account"
                                    : transactionDetails.id
                                    ? "Income Account"
                                    : transactionDetails.account
                                }}
                              </div>
                              <button
                                class="cursor-pointer select-elem-con form- text-left col-md-12"
                                :class="{
                                  'col-12': splittedTransactions.length === 1,
                                }"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style="
                                  border: 1px solid #ced4da;
                                  border-radius: 4px;
                                  background: rgb(253, 253, 253);
                                "
                              >
                                <span class="text-left">{{
                                  splittedTransactions.length === 0 ||
                                  !splittedTransactions[index].text
                                    ? "Select"
                                    : splittedTransactions[index].text
                                }}</span>
                                <span class="float-right"
                                  ><el-icon :size="16"> <ArrowDown /> </el-icon
                                ></span>
                              </button>
                              <div
                                class="dropdown-menu cursor-pointer w-100"
                                id="noTransfrom"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div class="row">
                                  <div class="col-md-11 mx-auto">
                                    <input
                                      type="text"
                                      placeholder="Search..."
                                      class="form-control ofering mb-1 close-modal"
                                      v-model="incomeExpenseSearchText"
                                    />
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-11">
                                    <a
                                      class="dropdown-item cursor-pointer"
                                      v-for="(
                                        item, indx
                                      ) in expenseIncomeAccounts"
                                      :key="indx"
                                      @click="categories(item, index)"
                                      >{{ item.text }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-md-6 mt-3"
                              v-if="splittedTransactions.length > 1"
                            >
                              <div class="col-md-12 px-0 label-text">
                                Amount
                              </div>
                              <div class="d-flex">
                                <el-input
                                  type="text"
                                  placeholder="amount"
                                  :class="{
                                    'col-11': splittedTransactions.length > 1,
                                  }"
                                  class="w-100 px-0"
                                  v-model="i.amount"
                                  v-if="splittedTransactions.length > 1"
                                /><span
                                  v-if="splittedTransactions.length > 1"
                                  class="col-1 px-1"
                                  @click="removeSplit(index)"
                                  ><el-icon> <Delete /> </el-icon
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-12 mt-3" v-if="i.showDonorField">
                            <!-- Hello -->
                            <div class="label-text">Select Member</div>
                            <SearchMember
                              searchMember="Search for Member"
                              @selectmember="donorSelected"
                              :index="index"
                            />
                          </div>
                          <div class="col-md-12">
                            <div
                              class="d-flex justify-content-end"
                              v-if="
                                i.donor ||
                                transactionDetails.account ===
                                  'Income Account' ||
                                (transactionDetails.creditSplitAccounts &&
                                  transactionDetails.creditSplitAccounts
                                    .length) > 0
                              "
                            >
                              <div
                                class="mt-1 vendor s-12 c-pointer d-flex align-items-center"
                                @click="
                                  () => (i.showDonorField = !i.showDonorField)
                                "
                              >
                                <el-icon v-if="!i.showDonorField"
                                  ><Plus
                                /></el-icon>
                                <el-icon v-else><Minus /></el-icon>
                                <span class="mt-1">
                                  {{
                                    i.donor
                                      ? i.donor
                                      : transactionDetails.account ===
                                          "Income Account" ||
                                        (transactionDetails.creditSplitAccounts &&
                                          transactionDetails.creditSplitAccounts
                                            .length) > 0
                                      ? "Add Contact"
                                      : ""
                                  }}</span
                                >
                              </div>
                              <!-- <div class="dot ml-2"></div> -->
                              <!-- <div class="mt-2 ml-2 vendor">Include Tax Sales</div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div
                      class="col-md-12 px-0 d-flex align-items-center text-dak bg-white"
                      @click="splitTransaction"
                    >
                      <div
                        class="col-md-12 split px-0 d-flex align-items-center"
                      >
                        <!-- <el-tooltip
                          class="box-item"
                          effect="dark"
                          content=""
                          placement="top"
                        > -->
                        <!-- <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="Create multiple categories to associate(split) this trasaction between different accounts."
                          placement="top"
                        > -->
                        <div>
                          Split this
                          {{
                            transactionDetails.id &&
                            transactionDetails.debitSplitAccounts &&
                            transactionDetails.debitSplitAccounts.length > 0
                              ? "expense"
                              : transactionDetails.id
                              ? "income"
                              : transactionDetails.account === "Expense Account"
                              ? "expense"
                              : "income"
                          }}
                          <!-- <div>Split this {{ transactionDetails.account === 'Expense Account' ? 'expense' : 'income' }} -->
                          <!-- <el-icon>
                <InfoFilled />
              </el-icon> -->
                        </div>
                        <!-- </el-tooltip> -->
                      </div>
                    </div>
                    <!-- <div class="col-3 line pl-0">
          <hr />
        </div> -->
                    <div
                      class="error-div col-10 offset-1 mt-3"
                      v-if="splitTotalAmount > transacObj.amount"
                    >
                      <div class="row">
                        <div class="col-1">
                          <el-icon>
                            <Warning />
                          </el-icon>
                        </div>
                        <p class="error-message col-10 pl-0">
                          The sum of the above lines should not exceed the total
                          deposit amount of {{ transacObj.amount }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 font-weight-bold s-16 text-right text-dak">
            <span>
              {{
                isNaN(splitTotalAmount) || !splitTotalAmount
                  ? ""
                  : Math.round(splitTotalAmount).toLocaleString()
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div
          class="col-md-12 text-center mt-4"
          v-if="transacObj.amount && !formIsValid"
        >
          <span class="text-center text-danger fw-500">
            Cash Account amount must be equal to
            {{
              transactionDetails.id &&
              transactionDetails.debitSplitAccounts &&
              transactionDetails.debitSplitAccounts.length > 0
                ? "Expense"
                : transactionDetails.id
                ? "income"
                : transactionDetails.account === "Expense Account"
                ? "Expense"
                : "Income"
            }}
            amount</span
          >
        </div>
        <div class="col-12 mt-3">
          <div class="w-100 font-weight-bold s-14 text-dak">Notes</div>
          <el-input
            v-model="transacObj.note"
            type="textarea"
            placeholder="Write a note here"
            :rows="3"
            class="w-100"
          />
        </div>
        <div class="col-md-12 mt-3">
          <div class="row">
            <!-- <el-button class="mt-1" text>View uploaded file</el-button> -->
            <div class="col-md-12 px-0">
              <el-upload
                class="col-md-12 mt-1 d-flex"
                action=""
                multiple
                :on-remove="handleRemove"
                accept="image/*, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :show-file-list="true"
                :on-change="chooseFile"
                :limit="1"
                :auto-upload="false"
              >
                <el-button
                  class="mr-2 primary--text upload-area-btn bg-white"
                  round
                  :loading="loadingFile"
                >
                  <span><UploadIcon class="w-10 h-10 mr-1" /></span>
                  <span style="color: #0745af" class="fw-400 s-12"
                    >Upload a file</span
                  ></el-button
                >
                <div class="s-8 text-dak fw-400 text-center">
                  <!-- Accepts file with image and pdf files only -->
                  Accepts image & pdf files only
                </div>
              </el-upload>
            </div>
            <div></div>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-end mb-2 mt-5">
          <div class="text-center cpon mr-2">
            <el-button
              style="border: 1px solid #aca6a6 !important"
              class="border-0 d-flex medium justify-content-center"
              round
              size="large"
              @click="closeTransac"
            >
              <span class="font-weight-600 s-16"> Cancel </span>
            </el-button>
          </div>
          <div class="text-center cpon">
            <el-button
              class="text-white border-0 medium d-flex justify-content-center"
              :loading="savingAccount"
              :color="primarycolor"
              round
              size="large"
              :disabled="!formIsValid || savingAccount"
              @click="saveIncome"
            >
              <span>
                {{ transactionDetails.id ? "Update" : "Save" }}
              </span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  nextTick,
  inject,
  watch,
  watchEffect,
  proxyRefs,
} from "vue";
import UploadIcon from "../../../components/icons/UploadIcon.vue";
import transaction_service from "../../../services/financials/transaction_service";
import chart_of_accounts from "../../../services/financials/chart_of_accounts";
import SearchMember from "../../../components/search/SearchMember";
import dateFormatter from "../../../services/dates/dateformatter";
import store from "../../../store/store";
import { ElNotification } from "element-plus";
import media_service from "../../../services/media/media_service";
export default {
  components: { SearchMember, UploadIcon },
  props: ["transactionDetails", "showEditTransaction", "gettingSelectedTrsn"],
  setup(props, { emit }) {
    const showAccount = ref(false);
    const fileImage = ref(false);
    const cashandbank = ref([]);
    const accountText = ref("");
    const selectedFileUrl = ref("");
    const accountType = ref([]);
    const primarycolor = inject("primarycolor");
    const liabilities = ref(["Credit Card", "Loan and Line of Credit"]);
    const showUncategorized = ref(false);
    const uncategorizedText = ref("");
    const transacObj = ref(props.transactionDetails);
    const splittedTransactions = ref([{ ...props.transactionDetails }]);
    const savingAccount = ref(false);
    const loadingFile = ref(false);
    const fileResponse = ref(null);

    const amountRef = ref("");
    const descrp = ref("");
    const selectedCashAccount = ref({});
    const selectedIncomeOrExpenseAccount = ref({});
    const selectedInComeExpenseAccount = ref({});
    const iSoStringFormat = ref("");
    watchEffect(() => {
      if (transacObj.value.date) {
        iSoStringFormat.value = dateFormatter.getISOStringGMT(
          transacObj.value.date
        );
      }
    });

    const filterAccount = computed(() => {
      if (accountText.value !== "" && accountType.value.length > 0) {
        return accountType.value.filter((i) => {
          if (i)
            return i.toLowerCase().includes(accountText.value.toLowerCase());
        });
      } else {
        return accountType.value;
      }
    });

    const filterLiabilities = computed(() => {
      if (accountText.value !== "" && liabilities.value.length > 0) {
        return liabilities.value.filter((i) => {
          if (i)
            return i.toLowerCase().includes(accountText.value.toLowerCase());
        });
      } else {
        return liabilities.value;
      }
    });

    const hideModals = (e) => {
      if (!e.target.classList.contains("close-modal")) {
        showAccount.value = false;
        showUncategorized.value = false;
      }
    };

    const handleRemove = () => {
      selectedFileUrl.value = "";
    };

    const filterUncategorizedAsset = computed(() => {
      if (uncategorizedText.value !== "" && accountType.value.length > 0) {
        return accountType.value.filter((i) => {
          if (i)
            return i
              .toLowerCase()
              .includes(uncategorizedText.value.toLowerCase());
        });
      } else {
        return accountType.value;
      }
    });

    const filterUncategorizedLiabilities = computed(() => {
      if (uncategorizedText.value !== "" && liabilities.value.length > 0) {
        return liabilities.value.filter((i) => {
          if (i)
            return i
              .toLowerCase()
              .includes(uncategorizedText.value.toLowerCase());
        });
      } else {
        return liabilities.value;
      }
    });

    const categoryAccount = (e) => {
      transacObj.value.splitCategories[
        transacObj.value.splitCategories.length - 1
      ].category = e.target.innerHTML;
      transacObj.value.splitCategories[
        transacObj.value.splitCategories.length - 1
      ].showUncategorized = false;
      // let index = splitCategories.findIndex(i => )
    };

    const categories = (account, index) => {
      // transacObj.value.category = e.target.innerText;
      showUncategorized.value = !showUncategorized.value;
      selectedInComeExpenseAccount.value = account;
      splittedTransactions.value[index].accountID = account.id;
      splittedTransactions.value[index].text = account.text || account.name;

      console.log(account, "accounth");
    };

    const accountFlow = (e, account) => {
      // transacObj.value.accountFlow = e.target.innerText;
      showAccount.value = !showAccount.value;
      selectedCashAccount.value = account;
      console.log(account, "jjjj");
    };

    const splitWithdrawal = () => {
      transacObj.value.splitCategories.push({
        amount: 0,
      });
      nextTick(() => {
        amountRef.value.select();
      });
    };

    const deleteSplit = (index) => {
      transacObj.value.splitCategories.splice(index, 1);
    };

    const totalAmount = computed(() => {
      if (
        transacObj.value.splitCategories &&
        transacObj.value.splitCategories.length > 0
      ) {
        return transacObj.value.splitCategories.reduce((total, item) => {
          return total + parseInt(item.amount || 0);
        }, 0);
      } else {
        return 0;
      }
    });
    const splitTotalAmount = computed(() => {
      return splittedTransactions.value
        .map((i) => (i.amount ? Math.abs(+i.amount) : 0))
        .reduce((a, b) => a + b, 0);
    });

    const incomeExpenseSearchText = ref("");
    const splitAccountLabel = computed(() => {
      if (
        transactionDetails.id &&
        transactionDetails.debitSplitAccounts &&
        transactionDetails.debitSplitAccounts.length > 0
      ) {
        return "Expense Account";
      }

      if (
        transactionDetails.id &&
        transactionDetails.creditSplitAccounts &&
        transactionDetails.creditSplitAccounts.length > 0
      ) {
        return "Income Account";
      }

      return transactionDetails.account || "Select Account";
    });
    const expenseIncomeAccounts = computed(() => {
      const td = props.transactionDetails;
      let data = [];

      if (!td.account) {
        data = [...(expenseAccounts.value || []), ...(accountType.value || [])];
      } else if (td.account === "Income Account") {
        data = accountType.value || [];
      } else if (td.account === "Expense Account") {
        data = expenseAccounts.value || [];
      } else if (td.id) {
        if (td.debitSplitAccounts?.length) {
          data = expenseAccounts.value || [];
        } else if (td.creditSplitAccounts?.length) {
          data = accountType.value || [];
        }
      }

      if (!incomeExpenseSearchText.value) return data;

      return data.filter((i) =>
        i.text
          .toLowerCase()
          .includes(incomeExpenseSearchText.value.toLowerCase())
      );
    });

    // const expenseIncomeAccounts = computed(() => {
    //   let data = [];
    //   if (!props.transactionDetails.account) {
    //     data = [...expenseAccounts.value, accountType.value];
    //   }
    //   if (
    //     props.transactionDetails.id &&
    //     props.transactionDetails.debitSplitAccounts &&
    //     props.transactionDetails.debitSplitAccounts.length > 0
    //   ) {
    //     data = expenseAccounts.value;
    //   }
    //   if (
    //     props.transactionDetails.id &&
    //     props.transactionDetails.creditSplitAccounts &&
    //     props.transactionDetails.creditSplitAccounts.length > 0
    //   ) {
    //     data = accountType.value ? accountType.value : [];
    //   }
    //   if (props.transactionDetails.account === "Income Account") {
    //     data = accountType.value ? accountType.value : [];
    //   }
    //   if (props.transactionDetails.account === "Expense Account") {
    //     data = expenseAccounts.value;
    //   }
    //   if (!incomeExpenseSearchText.value) return data;
    //   return data.filter((i) =>
    //     i.text.toLowerCase().includes(incomeExpenseSearchText.value)
    //   );
    // });

    const closeTransac = () => {
      emit("close-it", false);
    };

    const gettingIncomeAccounts = ref(false);
    const getIncomeAccounts = async () => {
      try {
        gettingIncomeAccounts.value = true;
        const response = await transaction_service.getIncomeAccounts();
        accountType.value = response;
        gettingIncomeAccounts.value = false;
      } catch (error) {
        console.log(error);
        gettingIncomeAccounts.value = false;
      }
    };

    const expenseAccounts = ref([]);
    const gettingExpenseAccounts = ref(false);
    const getExpenseAccounts = async () => {
      try {
        gettingExpenseAccounts.value = true;
        const response = await transaction_service.getExpenseAccounts();
        expenseAccounts.value = response;
        gettingExpenseAccounts.value = false;
      } catch (error) {
        console.log(error);
        gettingExpenseAccounts.value = false;
      }
    };

    getExpenseAccounts();
    getIncomeAccounts();

    const accountTypes = ["assets", "liability", "income", "expense", "equity"];
    const accTypes = ["assets", "liability", "equity", "income", "expense"];

    const transactionalAccounts = computed(() => {
      if (!accountHeads.value || accountHeads.value.length === 0) return [];
      let accounts = [];
      for (let group of accountHeads.value) {
        accounts.push(group.accountHeadsDTO);
      }
      return accounts;
    });

    const constructSaveTransactionReqBody = () => {
      const reqBody = {
        // id: props.transactionDetails.id ? props.transactionDetails.id : "",
        amount: Math.abs(+transacObj.value.amount),
        // amount: Math.abs(+transacObj.value.amount),
        creditSplitAccounts: splittedTransactions.value.map((i) => {
          return {
            accountID: i.accountID,
            amount: Math.abs(
              splittedTransactions.value.length === 1
                ? +transacObj.value.amount
                : i.amount
                ? +i.amount
                : +transacObj.value.amount
            ),
            // amount: Math.abs(i.amount ? +i.amount : +transacObj.value.amount),
            contactID: i.donorId ? i.donorId : "",
            transactionID: i.transactionID,
          };
        }),
        date: iSoStringFormat.value,
        memo: transacObj.value.memo,
        note: transacObj.value.note,
        transactionNumber: props.transactionDetails.transactionNumber
          ? props.transactionDetails.transactionNumber
          : "",
        documentUrl: fileResponse.value?.pictureUrl,
        documentBlobName: fileResponse.value?.imageBlobName,
      };
      if (
        props.transactionDetails.account === "Expense Account" &&
        selectedCashAccount.value?.id
      ) {
        reqBody.creditAccountID = selectedCashAccount.value.id;
      } else if (
        props.transactionDetails.account === "Income Account" &&
        selectedCashAccount.value?.id
      ) {
        reqBody.debitAccountID = selectedCashAccount.value.id;
      }
      if (props.transactionDetails.id) {
        reqBody.id = props.transactionDetails.id;
      }
      return reqBody;
    };

    const toastMessage = (response) => {
      if (response.status) {
        ElNotification({
          type: "success",
          message: "Transaction saved successfully",
          duration: 3000,
        });
        store.dispatch("transaction/getTransaction");
        savingAccount.value = false;
        emit("reload");
      } else {
        ElNotification({
          type: "error",
          message: "The operation was not successful",
          duration: 3000,
        });
      }
    };

    const newIncome = ref({});
    const saveIncome = async () => {
      // Check if Date is selected
      if (!transacObj.value.date || transacObj.value.date === "") {
        ElNotification({
          type: "warning",
          message: "Please select a Date before saving.",
          duration: 3000,
        });
        return;
      }

      if (!transacObj.value.memo || transacObj.value.memo === "") {
        ElNotification({
          type: "warning",
          message: "Please add Description before saving.",
          duration: 3000,
        });
        return;
      }
      const invalidSplit = splittedTransactions.value.find((i) => !i.accountID);
      if (invalidSplit) {
        ElNotification({
          type: "warning",
          message: "Please select an account for each split transaction.",
          duration: 3000,
        });
        return;
      }
      if (
        props.transactionDetails.creditSplitAccounts !==
        props.transactionDetails.creditSplitAccounts < 0
      )
        try {
          let reqBody = {};
          savingAccount.value = true;
          if (
            props.transactionDetails.account === "Income Account" ||
            (props.transactionDetails.creditSplitAccounts &&
              props.transactionDetails.creditSplitAccounts.length > 0)
          ) {
            // transacObj.value.creditAccountID = selectedCashAccount.value.id;
            // transacObj.value.creditAccountID =
            //   selectedIncomeOrExpenseAccount.value.id;
            transacObj.value.debitAccountID = selectedCashAccount.value.id;
            reqBody = constructSaveTransactionReqBody();
            reqBody.category = "inflow";
            const response = await transaction_service.saveIncome(reqBody);
            // savingAccount.value = false;
            toastMessage(response);
          } else {
            const body = {
              debitSplitAccounts: splittedTransactions.value.map((i) => {
                return {
                  accountID: i.accountID,
                  amount: Math.abs(
                    splittedTransactions.value.length === 1
                      ? transacObj.value.amount
                      : i.amount
                      ? +i.amount
                      : +transacObj.value.amount
                  ),
                  // amount: Math.abs(i.amount ? +i.amount : +transacObj.value.amount),
                  contactID: i.donorId ? i.donorId : "",
                  transactionID: i.transactionID,
                };
              }),
              creditAccountID: selectedCashAccount.value.id,
              date: iSoStringFormat.value,
              memo: transacObj.value.memo,
              note: transacObj.value.note,
              transactionNumber: props.transactionDetails.transactionNumber
                ? props.transactionDetails.transactionNumber
                : "",
              amount: Math.abs(+transacObj.value.amount),
              // amount: Math.abs(+transacObj.value.amount),
              category: "outflow",
              documentUrl: fileResponse.value?.pictureUrl,
              documentBlobName: fileResponse.value?.imageBlobName,
            };

            if (props.transactionDetails.id) {
              body.id = props.transactionDetails.id;
            }
            const response = await transaction_service.saveExpense(body);
            toastMessage(response);
          }
          emit("close-it", false);
        } catch (error) {
          // savingAccount.value = false;
          console.log(error);
        }
    };

    // const getSplittedAccountNames = () => {
    //   splittedTransactions.value = splittedTransactions.value.map((i) => {
    //     const accIncome = accountType.value.find((j) => j.id === i.accountID);
    //     const accExpense = expenseAccounts.value.find(
    //       (j) => j.id === i.accountID
    //     );
    //     i.text = accIncome
    //       ? accIncome.text
    //       : accExpense
    //       ? accExpense.text
    //       : "Income Account";
    //     return i;
    //   });
    // };
    // const getSplittedAccountNames = () => {
    //   const incomeList = accountType.value || [];
    //   const expenseList = expenseAccounts.value || [];

    //   splittedTransactions.value = splittedTransactions.value.map((item) => {
    //     const matchedIncome = incomeList.find(
    //       (acc) => acc.id === item.accountID
    //     );
    //     const matchedExpense = expenseList.find(
    //       (acc) => acc.id === item.accountID
    //     );

    //     return {
    //       ...item,
    //       text:
    //         matchedIncome?.text || matchedExpense?.text || "Unknown Account",
    //     };
    //   });
    // };
    watch(
      [accountType, expenseAccounts],
      ([income, expense]) => {
        if (
          splittedTransactions.value.length &&
          (income?.length || expense?.length)
        ) {
          getSplittedAccountNames();
        }
      },
      { immediate: true }
    );
    const getSplittedAccountNames = () => {
      const incomeList = accountType.value || [];
      const expenseList = expenseAccounts.value || [];

      splittedTransactions.value = splittedTransactions.value.map((item) => {
        const matchedIncome = incomeList.find(
          (acc) => acc.id === item.accountID
        );
        const matchedExpense = expenseList.find(
          (acc) => acc.id === item.accountID
        );

        const label =
          matchedIncome?.text ||
          matchedIncome?.name ||
          matchedExpense?.text ||
          matchedExpense?.name;

        return {
          ...item,
          text: label || "Select Account",
        };
      });
    };

    const dateField = ref(null);
    watch(
      () => props.transactionDetails,
      (data) => {
        if (!data) return;

        // Assign base fields
        transacObj.value.date = data.date;
        transacObj.value.amount = Math.abs(data.amount || 0);
        transacObj.value.memo = data.memo;
        transacObj.value.note = data.note;
        selectedCashAccount.value = data.account;

        // Default split
        splittedTransactions.value = [{}];

        if (data.id) {
          // Set splits from debit or credit
          if (data.debitSplitAccounts?.length) {
            splittedTransactions.value = data.debitSplitAccounts.map(
              (item) => ({
                ...item,
                amount: Math.abs(item.amount || 0),
              })
            );
          } else if (data.creditSplitAccounts?.length) {
            splittedTransactions.value = data.creditSplitAccounts.map(
              (item) => ({
                ...item,
                amount: Math.abs(item.amount || 0),
              })
            );
          } else {
            // No split data: fallback to account IDs
            if (data.creditAccountID) {
              transacObj.value.creditAccountID = data.creditAccountID;
              console.log(
                "Credit Account ID set from transaction details",
                data.creditAccountID
              );
            }
            if (data.debitAccountID) {
              transacObj.value.debitAccountID = data.debitAccountID;
              console.log(
                "Credit Account ID set from transaction details",
                data.debitAccountID
              );
            }
          }

          // Get account display names or text
          getSplittedAccountNames();
        }
      },
      { immediate: true }
    );
    // watch(
    //   () => props.transactionDetails,
    //   (data) => {
    //     transacObj.value.date = data.date;
    //     transacObj.value.amount = Math.abs(data.amount);
    //     transacObj.value.memo = data.memo;
    //     transacObj.value.note = data.note;
    //     splittedTransactions.value = [{}];
    //     selectedCashAccount.value = data.account;

    //     if (props.transactionDetails.id) {
    //       // Set date (your current logic)
    //       transacObj.value.date = data.date;

    //       // Check for split accounts
    //       if (data.debitSplitAccounts && data.debitSplitAccounts.length > 0) {
    //         splittedTransactions.value = data.debitSplitAccounts.map((i) => {
    //           i.amount = Math.abs(i.amount);
    //           return i;
    //         });
    //       } else if (
    //         data.creditSplitAccounts &&
    //         data.creditSplitAccounts.length > 0
    //       ) {
    //         splittedTransactions.value = data.creditSplitAccounts.map((i) => {
    //           i.amount = Math.abs(i.amount);
    //           return i;
    //         });
    //       } else {
    //         // No splits, use main account info
    //         if (data.creditAccountID) {
    //           transacObj.value.creditAccountID = data.creditAccountID;
    //         }
    //         if (data.debitAccountID) {
    //           transacObj.value.debitAccountID = data.debitAccountID;
    //         }
    //       }

    //       getSplittedAccountNames();
    //     }
    //   }
    // );
    // watch(
    //   () => props.transactionDetails,
    //   (data) => {
    //     transacObj.value.date = data.date;
    //     transacObj.value.amount = Math.abs(data.amount);
    //     transacObj.value.memo = data.memo;
    //     transacObj.value.note = data.note;
    //     splittedTransactions.value = [{}];
    //     selectedCashAccount.value = data.account;

    //     if (props.transactionDetails.id) {
    //       transacObj.value.date = data.date;
    //       if (data.debitSplitAccounts && data.debitSplitAccounts.length > 0) {
    //         splittedTransactions.value = data.debitSplitAccounts.map((i) => {
    //           i.amount = Math.abs(i.amount);
    //           return i;
    //         });
    //       } else {
    //         splittedTransactions.value = data.creditSplitAccounts.map((i) => {
    //           i.amount = Math.abs(i.amount);
    //           return i;
    //         });
    //       }
    //       getSplittedAccountNames();
    //     }
    //   }
    // );

    const accountHeads = ref([]);
    const getAccountHeads = async () => {
      try {
        const response = await chart_of_accounts.getAccountHeads();
        accountHeads.value = response;
      } catch (error) {
        console.log(error);
      }
    };
    getAccountHeads();

    const getCashAndBank = async () => {
      try {
        const response = await transaction_service.getCashAndBank();
        cashandbank.value = response;
        selectedCashAccount.value =
          cashandbank.value && cashandbank.value[0] ? cashandbank.value[0] : {};
      } catch (error) {
        console.log(error);
      }
    };
    getCashAndBank();

    const filteredCashandBank = computed(() => {
      if (!cashandbank.value || cashandbank.value.length === 0) return [];
      return cashandbank.value.filter((i) =>
        i.text.toLowerCase().includes(accountText.value)
      );
    });

    const splitTransaction = () => {
      splittedTransactions.value.push({});
    };

    const showDonorField = ref(false);
    const addDonor = () => {};

    const donorSelected = (memberData) => {
      splittedTransactions.value[memberData.index].donorId =
        memberData.member.id;
      splittedTransactions.value[memberData.index].donor =
        memberData.member.name;
      splittedTransactions.value[memberData.index].showDonorField = false;
    };

    const formIsValid = computed(() => {
      if (!transacObj.value.amount) return false;
      if (splittedTransactions.value.length === 1) return true;
      const result = splittedTransactions.value
        .map((i) => {
          return i.amount ? Math.abs(+i.amount) : 0;
        })
        .reduce((a, b) => a + b);
      console.log(result, "jjjj");
      const amount = transacObj.value.amount ? +transacObj.value.amount : 0;
      return Math.abs(amount) === result;
    });

    const removeSplit = (index) => {
      splittedTransactions.value.splice(index, 1);
    };

    const chooseFile = async (e) => {
      loadingFile.value = true;
      let formData = new FormData();
      formData.append("mediaFileImage", e.raw);
      try {
        let data = await media_service.uploadFileAndImage(formData);
        console.log("uploaded file");
        loadingFile.value = false;
        fileResponse.value = data;
      } catch (error) {
        loadingFile.value = false;
        console.log(error);
      }
    };

    return {
      splitAccountLabel,
      selectedInComeExpenseAccount,
      showAccount,
      iSoStringFormat,
      accountText,
      filterAccount,
      accountType,
      filterLiabilities,
      liabilities,
      hideModals,
      selectedFileUrl,
      showUncategorized,
      uncategorizedText,
      filterUncategorizedAsset,
      filterUncategorizedLiabilities,
      closeTransac,
      transacObj,
      categoryAccount,
      splitWithdrawal,
      deleteSplit,
      accountFlow,
      handleRemove,
      fileImage,
      totalAmount,
      amountRef,
      descrp,
      categories,
      chooseFile,
      primarycolor,
      transactionalAccounts,
      accountTypes,
      expenseIncomeAccounts,
      splitTotalAmount,
      saveIncome,
      newIncome,
      selectedCashAccount,
      selectedIncomeOrExpenseAccount,
      gettingIncomeAccounts,
      gettingExpenseAccounts,
      accountHeads,
      accTypes,
      cashandbank,
      filteredCashandBank,
      incomeExpenseSearchText,
      splitTransaction,
      splittedTransactions,
      donorSelected,
      showDonorField,
      addDonor,
      formIsValid,
      removeSplit,
      dateField,
      savingAccount,
      loadingFile,
      fileResponse,
    };
  },
};
</script>

<style scoped>
#noTransfrom {
  transform: none !important;
  max-height: 300px;
  overflow: auto;
  top: inherit !important;
}

.hover-text {
  background-color: white;
}

.hover-text:hover {
  background-color: rgb(248, 247, 247);
}

.parent-desc.first {
  color: #8898aa;
  font-size: 20px;
  font-weight: 700;
  color: #000000;
}
.select-elem-con {
  padding: 10px 10px !important;
  justify-content: space-between;
  background: rgb(253, 253, 253);
  border: 1px solid #787878 !important;
  height: 44px !important;
  align-items: center;
}

/* .select-elem-con {
  padding: 10px 10px;
  justify-content: space-between;
  background: rgb(253, 253, 253);
  border: 1px solid #a5a5a5 !important;
} */
.form-control {
  height: 44px !important;
}

.style-account {
  box-shadow: 0px 3px 15px #797e8159;
  position: absolute;
  background: white;
  z-index: 1;
  width: 130%;
  max-height: 14em;
  overflow-y: scroll;
}

.style-account div div div:hover {
  /* background-color: #ecf0f3; */
  cursor: pointer;
}

/* .input-width {
  width: 100%
}

.input-width {
  width: 100%
}

@media (min-width: 992px) {
  .input-width {
    width: 350px
  }

} */

.style-uncategorized {
  box-shadow: 0px 3px 15px #797e8159;
  position: absolute;
  background: white;
  z-index: 1;
  width: 90%;
  max-height: 14em;
  overflow-y: scroll;
}

.style-uncategorized div div div:hover {
  /* background-color: #ecf0f3; */
  cursor: pointer;
}

.menu-height {
  max-height: 400px;
  overflow: scroll;
}
.upload-area-btn {
  border: 1px dashed #0745af !important;
  color: #0745af !important;
}

.desc-head {
  font-weight: 700;
}

.desc {
  color: #9b9a9c;
  /* opacity: 0.7; */
}

.vendor {
  color: #0745af;
  font-weight: 400;
  font-size: 14px;
  /* text-decoration: underline; */
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  align-self: center;
  background: #686868;
  margin-top: 5px;
}

.split {
  /* border: 2px solid #bebebe; */
  color: #0745af !important;
  /* border-radius: 60px; */
  font-size: 12px;
  font-weight: 500;
  /* border: 1px solid #0745af; */
  /* width: 135px !important; */
  /* height: 31.5px; */
  /* box-shadow: 0px 4px 4px 0px #00000040; */
  cursor: pointer;
  text-decoration: underline !important;
}

.line {
  position: relative;
  top: 5px;
  color: #ffffff;
}

.modified {
  font-size: 0.9em;
}

.label-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 1px;
  color: #000000;
}

.error-div {
  background: #fff8f8;
  border-color: #ffe9e9;
  padding: 10px 5px;
  margin-bottom: 24px;
  border-radius: 8px;
  border: 1px solid transparent;
  border-left: 5px solid #b52626;
}

.error-message {
  margin-bottom: 0;
  font-size: 0.9em;
}

.adjust-left {
  margin-left: 78px;
}

@media (max-width: 1203px) {
  .split {
    width: 400px !important;
  }
}
@media (max-width: 770px) {
  .split {
    /* border: 2px solid #bebebe; */
    width: 350px !important;
  }
}
@media (max-width: 450px) {
  .split {
    /* border: 2px solid #bebebe; */
    width: 300px !important;
  }
}
@media (max-width: 350px) {
  .split {
    /* border: 2px solid #bebebe; */
    width: 100% !important;
  }
}
</style>
